export const SKILL_LIST = [{
  img: 'EnrichMarket.png',
  title: '丰富行情',
  desc: '提供A股、B股、港股、美股、债券、CDR、沪伦通、股指期货、外汇、股票期权、现货、基金等行情展示'
}, {
  img: 'Fulltransaction.png',
  title: '全量交易',
  desc: '支持所有交易所要求的标准化业务，支持批量新股申购，港股通，场内基金，场外基金等交易'
}, {
  img: 'IntelligentInformation.png',
  title: '智能资讯',
  desc: '专业的财经内容生产团队，结合机器算法，提供千人千面的资讯推荐'
}, {
  img: 'conversation.png',
  title: '智能对话',
  desc: '结合同花顺i问财，实现了客服类问题及诊股、选股类问题的智能问答'
}, {
  img: 'DataCenter.png',
  title: '数据中心',
  desc: '业绩公告、国家队持股、限售解禁、增减持计划、宏观数据、等海量数据深析投资机会'
}, {
  img: 'StockF10.png',
  title: '股票F10',
  desc: 'F10可提供全面的企业资料、深入的财务解读、新鲜的公司动态等近百项功能'
}, {
  img: 'InvestmentAdvisor.png',
  title: '投资顾问',
  desc: '涵盖直播、文章、视频、服务包、组合、策略等多种服务，为投资顾问打造一站式线上服务平台'
}, {
  img: 'FinancialMall.png',
  title: '理财商城',
  desc: '可根据客户风险偏好以及过往交易自动推荐相似产品，为金融机构提供一站式金融产品线上商城'
}, {
  img: 'openingOperation.png',
  title: '开户运营',
  desc: '可视化数据支持，实现开户业务优化与效率提升'
}];